// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  display: flex;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.main-content {
  flex: 1 1;
  min-width: 0; /* Allow flex item to shrink below content size */
  padding: 2rem;
  background-color: #f6f8ff;
  min-height: 100vh;
  overflow-x: hidden;
  transition: margin-left 0.2s ease;
  will-change: margin-left;
}

/* Mobil görünüm için */
@media (max-width: 768px) {
  .main-content {
    margin-left: 0 !important; /* Mobilde margin-left sıfırlanmalı */
    padding: 1rem;
    padding-top: 4rem; /* Üstteki menu butonu için alan */
  }
}

.page-content {
  background-color: white;
  border-radius: 0.5rem;
  padding: 1.5rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

/* Özel scrollbar stili */
.sidebar-scroll {
  scrollbar-width: thin;
  scrollbar-color: #CBD5E0 #EDF2F7;
}

.sidebar-scroll::-webkit-scrollbar {
  width: 6px;
}

.sidebar-scroll::-webkit-scrollbar-track {
  background: #EDF2F7;
}

.sidebar-scroll::-webkit-scrollbar-thumb {
  background-color: #CBD5E0;
  border-radius: 3px;
}

/* ── v16 çerçevesi (yalnız V16_SHELL_PATHS'teki sayfalar, App.js AppShell) ──
   Gri uygulama zemini + gri sidebar; içerik 12px boşlukla dört kenarından gri
   görünen yuvarlak beyaz panelde, kendi içinde kayar. Widget zeminleri gri. */
.v16-app {
  min-height: 100vh;
  background: #f2f2f4;
}
.v16-panel {
  position: fixed;
  top: 12px;
  right: 12px;
  bottom: 12px;
  left: 60px; /* kapalı gri sidebar genişliği; sol gri şerit = sidebar */
  background: #ffffff;
  border-radius: 28px;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 2rem;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}
@media (max-width: 768px) {
  .v16-panel { left: 12px; padding: 1rem; padding-top: 4rem; }
}
.v16-enter { animation: v16-enter 320ms cubic-bezier(0.22, 1, 0.36, 1) both; }
@keyframes v16-enter {
  from { opacity: 0; transform: translateY(8px); }
  to { opacity: 1; transform: none; }
}
@media (prefers-reduced-motion: reduce) { .v16-enter { animation: none; } }

/* Dış widget kartları (rounded-3xl + bütçe kartı) gri, çerçevesiz, gölgesiz.
   İçlerindeki rounded-xl/2xl kutular beyaz kalır → tasarımdaki gri kart + beyaz çip. */
.v16-panel .bg-white.rounded-3xl,
.v16-panel .bg-white.rounded-2xl.ring-1 {
  background-color: #f6f6f8 !important;
  border-color: transparent !important;
  box-shadow: none !important;
}

/* Gri sidebar */
.sb-gray {
  background-color: #f2f2f4 !important;
  border-right-color: transparent !important;
}
.sb-gray .border-gray-100,
.sb-gray .border-gray-200 { border-color: transparent !important; }
.sb-gray .bg-white:not(.shadow-lg) { background-color: transparent !important; }
.sb-gray .bg-gray-50 { background-color: rgba(255, 255, 255, 0.65) !important; }
.sb-gray .bg-blue-50 {
  background-color: #ffffff !important;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06);
}
.sb-gray .hover\\:bg-gray-50:hover { background-color: rgba(255, 255, 255, 0.6) !important; }
.sb-gray.md\\:shadow-2xl { box-shadow: 8px 0 32px -12px rgba(15, 23, 42, 0.18) !important; }

/* Gri sidebar daha ince: kapalıyken 60px ve panel tam bu genişlikte başlar (sol aralık yok),
   böylece soldaki gri şerit = sidebar; ikonlar şeridin tam ortasında (30px).
   Normal sidebar'da 64/32. */
@media (min-width: 768px) {
  .sb-gray.md\\:w-16 { width: 60px !important; }
}
.sb-gray nav > ul { padding-left: 6px !important; padding-right: 6px !important; }
.sb-gray .h-16.px-\\[18px\\] { padding-left: 16px !important; padding-right: 16px !important; }
.sb-gray .left-\\[18px\\] { left: 16px !important; }
.sb-gray .relative.px-2.py-4 { padding-left: 6px !important; padding-right: 6px !important; }
.sb-gray .flex-shrink-0.border-t.px-2 { padding-left: 6px !important; padding-right: 6px !important; }
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,SAAO;EACP,YAAY,EAAE,iDAAiD;EAC/D,aAAa;EACb,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,iCAAiC;EACjC,wBAAwB;AAC1B;;AAEA,uBAAuB;AACvB;EACE;IACE,yBAAyB,EAAE,qCAAqC;IAChE,aAAa;IACb,iBAAiB,EAAE,kCAAkC;EACvD;AACF;;AAEA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,eAAe;EACf,wCAAwC;AAC1C;;AAEA,yBAAyB;AACzB;EACE,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;;8EAE8E;AAC9E;EACE,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,YAAY;EACZ,UAAU,EAAE,0DAA0D;EACtE,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,4CAA4C;AAC9C;AACA;EACE,aAAa,UAAU,EAAE,aAAa,EAAE,iBAAiB,EAAE;AAC7D;AACA,aAAa,8DAA8D,EAAE;AAC7E;EACE,OAAO,UAAU,EAAE,0BAA0B,EAAE;EAC/C,KAAK,UAAU,EAAE,eAAe,EAAE;AACpC;AACA,0CAA0C,aAAa,eAAe,EAAE,EAAE;;AAE1E;uFACuF;AACvF;;EAEE,oCAAoC;EACpC,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA,gBAAgB;AAChB;EACE,oCAAoC;EACpC,0CAA0C;AAC5C;AACA;4BAC4B,oCAAoC,EAAE;AAClE,qCAAqC,wCAAwC,EAAE;AAC/E,uBAAuB,sDAAsD,EAAE;AAC/E;EACE,oCAAoC;EACpC,4CAA4C;AAC9C;AACA,oCAAoC,qDAAqD,EAAE;AAC3F,0BAA0B,8DAA8D,EAAE;;AAE1F;;6BAE6B;AAC7B;EACE,oBAAoB,sBAAsB,EAAE;AAC9C;AACA,oBAAoB,4BAA4B,EAAE,6BAA6B,EAAE;AACjF,6BAA6B,6BAA6B,EAAE,8BAA8B,EAAE;AAC5F,0BAA0B,qBAAqB,EAAE;AACjD,+BAA+B,4BAA4B,EAAE,6BAA6B,EAAE;AAC5F,wCAAwC,4BAA4B,EAAE,6BAA6B,EAAE","sourcesContent":[".App {\n  display: flex;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.main-content {\n  flex: 1;\n  min-width: 0; /* Allow flex item to shrink below content size */\n  padding: 2rem;\n  background-color: #f6f8ff;\n  min-height: 100vh;\n  overflow-x: hidden;\n  transition: margin-left 0.2s ease;\n  will-change: margin-left;\n}\n\n/* Mobil görünüm için */\n@media (max-width: 768px) {\n  .main-content {\n    margin-left: 0 !important; /* Mobilde margin-left sıfırlanmalı */\n    padding: 1rem;\n    padding-top: 4rem; /* Üstteki menu butonu için alan */\n  }\n}\n\n.page-content {\n  background-color: white;\n  border-radius: 0.5rem;\n  padding: 1.5rem;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n/* Özel scrollbar stili */\n.sidebar-scroll {\n  scrollbar-width: thin;\n  scrollbar-color: #CBD5E0 #EDF2F7;\n}\n\n.sidebar-scroll::-webkit-scrollbar {\n  width: 6px;\n}\n\n.sidebar-scroll::-webkit-scrollbar-track {\n  background: #EDF2F7;\n}\n\n.sidebar-scroll::-webkit-scrollbar-thumb {\n  background-color: #CBD5E0;\n  border-radius: 3px;\n}\n\n/* ── v16 çerçevesi (yalnız V16_SHELL_PATHS'teki sayfalar, App.js AppShell) ──\n   Gri uygulama zemini + gri sidebar; içerik 12px boşlukla dört kenarından gri\n   görünen yuvarlak beyaz panelde, kendi içinde kayar. Widget zeminleri gri. */\n.v16-app {\n  min-height: 100vh;\n  background: #f2f2f4;\n}\n.v16-panel {\n  position: fixed;\n  top: 12px;\n  right: 12px;\n  bottom: 12px;\n  left: 60px; /* kapalı gri sidebar genişliği; sol gri şerit = sidebar */\n  background: #ffffff;\n  border-radius: 28px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding: 2rem;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n}\n@media (max-width: 768px) {\n  .v16-panel { left: 12px; padding: 1rem; padding-top: 4rem; }\n}\n.v16-enter { animation: v16-enter 320ms cubic-bezier(0.22, 1, 0.36, 1) both; }\n@keyframes v16-enter {\n  from { opacity: 0; transform: translateY(8px); }\n  to { opacity: 1; transform: none; }\n}\n@media (prefers-reduced-motion: reduce) { .v16-enter { animation: none; } }\n\n/* Dış widget kartları (rounded-3xl + bütçe kartı) gri, çerçevesiz, gölgesiz.\n   İçlerindeki rounded-xl/2xl kutular beyaz kalır → tasarımdaki gri kart + beyaz çip. */\n.v16-panel .bg-white.rounded-3xl,\n.v16-panel .bg-white.rounded-2xl.ring-1 {\n  background-color: #f6f6f8 !important;\n  border-color: transparent !important;\n  box-shadow: none !important;\n}\n\n/* Gri sidebar */\n.sb-gray {\n  background-color: #f2f2f4 !important;\n  border-right-color: transparent !important;\n}\n.sb-gray .border-gray-100,\n.sb-gray .border-gray-200 { border-color: transparent !important; }\n.sb-gray .bg-white:not(.shadow-lg) { background-color: transparent !important; }\n.sb-gray .bg-gray-50 { background-color: rgba(255, 255, 255, 0.65) !important; }\n.sb-gray .bg-blue-50 {\n  background-color: #ffffff !important;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06);\n}\n.sb-gray .hover\\:bg-gray-50:hover { background-color: rgba(255, 255, 255, 0.6) !important; }\n.sb-gray.md\\:shadow-2xl { box-shadow: 8px 0 32px -12px rgba(15, 23, 42, 0.18) !important; }\n\n/* Gri sidebar daha ince: kapalıyken 60px ve panel tam bu genişlikte başlar (sol aralık yok),\n   böylece soldaki gri şerit = sidebar; ikonlar şeridin tam ortasında (30px).\n   Normal sidebar'da 64/32. */\n@media (min-width: 768px) {\n  .sb-gray.md\\:w-16 { width: 60px !important; }\n}\n.sb-gray nav > ul { padding-left: 6px !important; padding-right: 6px !important; }\n.sb-gray .h-16.px-\\[18px\\] { padding-left: 16px !important; padding-right: 16px !important; }\n.sb-gray .left-\\[18px\\] { left: 16px !important; }\n.sb-gray .relative.px-2.py-4 { padding-left: 6px !important; padding-right: 6px !important; }\n.sb-gray .flex-shrink-0.border-t.px-2 { padding-left: 6px !important; padding-right: 6px !important; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
